import React from 'react';

const IconUpload = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" /><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" /></svg>;
const IconServer = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" ry="2" /><rect x="2" y="14" width="20" height="8" rx="2" ry="2" /><line x1="6" y1="6" x2="6.01" y2="6" /><line x1="6" y1="18" x2="6.01" y2="18" /></svg>;
const IconTrend = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>;

const STEPS = [
    { Icon: IconUpload, cls: 'blue', no: 'Step 01', t: 'Connect your clients', d: 'Add one or more client companies and invite your team. One structured workspace keeps every engagement organised from day one.' },
    { Icon: IconServer, cls: 'pink', no: 'Step 02', t: 'Let AI do the groundwork', d: 'Clarence interrogates the client’s documents and pre-populates the diligence modules — you review and refine instead of starting from a blank page.' },
    { Icon: IconTrend, cls: 'green', no: 'Step 03', t: 'Deliver insight, grow revenue', d: 'Turn the outputs into higher-value advisory. Improve service margins, unlock new revenue streams, and win introductions to new clients.' },
];

const AccountantsHowItWorks = () => (
    <section id="how-it-works" className="lp-acc-steps-sec">
        <div className="lp-eyebrow" data-lp-reveal>
            <span className="lp-ww-eyebrow">How it works</span>
        </div>
        <h2 className="lp-h2 lp-acc-steps-head" data-lp-reveal data-lp-delay="60">Three steps to more value for your clients.</h2>
        <p className="lp-acc-steps-sub" data-lp-reveal data-lp-delay="120">From onboarding to ongoing advisory — Diligentsia structures the work so you can focus on the insight.</p>
        <div className="lp-acc-steps">
            {STEPS.map(({ Icon, cls, no, t, d }, i) => (
                <div className="lp-acc-stepcard" key={i} data-lp-reveal data-lp-delay={i * 120}>
                    <div className={`lp-acc-icon ${cls}`}><Icon /></div>
                    <div className="lp-acc-steplabel">{no}</div>
                    <h3>{t}</h3>
                    <p>{d}</p>
                </div>
            ))}
        </div>
    </section>
);

export default AccountantsHowItWorks;
